
import Vue from 'vue';

interface Computed {
  additionalLogo: string | null;
}

export default Vue.extend<unknown, unknown, Computed, unknown>({
  computed: {
    additionalLogo() {
      const channel = this.$channelConfig('settings').id;
      const category = this.$store.getters['category/getCategoryData'];
      if (channel === 'miestai' && category) {
        return `https://static.delfi.lt/portal/images/logo/miestai-${category.slug}.svg`;
      }

      return null;
    },
  },
});
